import React from 'react';
import './start.css';
import img1 from '../assets/image 32.png';
import Explore from '../components/common/explore';

const Start = () => {
  return (
    <div className="startpage">

      <div className="startcontainer">

        <img
          className="bg-image"
          src={img1}
          alt=""
        />

        <div className="overlay-base"></div>
        <div className="overlay-vignette"></div>

        <div className="light-leak-1"></div>
        <div className="light-leak-2"></div>

        <div className="scan"></div>
        <div className="grain"></div>

        <div className="particles"></div>

        <div className="title-glow"></div>

        <div className="logo"></div>

        <div className="home1">

          <div className="home2">

            <h1 className="ttt1">
              EGYPT
            </h1>

            <div className="divider">
              <div className="div-line"></div>
              <div className="div-dot"></div>
              <div className="div-line"></div>
            </div>

            <h5 className="fashionweek">
              FASHION WEEK
            </h5>

          </div>

          <Explore />

        </div>

      </div>

    </div>
  );
};

export default Start;